import { Widget } from '@digital/ui';
import { Table } from 'antd';
import update from 'immutability-helper';
import React, { useCallback, useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { getAllPergunta, Pergunta, UpdateManyPergunta } from '../../../api/minuta/Pergunta';
import { componentsSorting } from '../../../components/SortingTable';



interface TabelaPerguntasProps {
  atualizarTelaListaPergunta: () => void;
  atualizarResultTabelaPerguntaOrdenacao: boolean;
}

function TabelaPerguntas(props: TabelaPerguntasProps) {
  const [pergunta, setPergunta] = useState<Pergunta[]>([]);
  const { atualizarTelaListaPergunta, atualizarResultTabelaPerguntaOrdenacao } = props;

  useEffect(() => {
    async function getPergunta() {
      const result = await getAllPergunta();
      if (result) setPergunta(result);
    }
    getPergunta();
  }, []);

  useEffect(() => {
    getAllPergunta().then((result) => {
      if (result)
        setPergunta(result);
    })
  }, [atualizarResultTabelaPerguntaOrdenacao]);




  const collums = [
    {
      title: 'Ordem',
      dataIndex: 'ordenacao',
      width: '5%',
      key: 'ordem',
    },
    {
      title: 'Descrição da pergunta',
      dataIndex: 'descricao',
      width: '90%',
      key: 'descricao',
    },
  ];

  const moveRow = useCallback(
    (dragIndex, hoverIndex) => {
      const dragRow = pergunta[dragIndex];
      const respUpdate = update(pergunta, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragRow],
        ],
      });

      const ordem = respUpdate.map((ru, index) => {
        return { ...ru, ordenacao: index + 1 };
      });
      UpdateManyPergunta({ perguntas: ordem }).then(() => {
        atualizarTelaListaPergunta();
      });
      setPergunta(ordem);
    },
    [pergunta],
  );



  return (
    <Widget>
      <DndProvider
        backend={HTML5Backend}
      >
        <Table
          rowKey="id"
          dataSource={pergunta}
          columns={collums}
          components={componentsSorting}
          onRow={(record, index) => ({
            index,
            moveRow,
          })}
          pagination={false}
        />
      </DndProvider>
    </Widget>
  );
}

export default TabelaPerguntas;
